import { z } from 'zod'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v1/pagination'

export const notificationSettingSchema = z.object({
    created_at: z.coerce.date().transform((date) => {
        dayjs.extend(localizedFormat)

        return dayjs(date)
    }),
    is_enabled: z.boolean(),
    type_uuid: z.string().uuid(),
    updated_at: z.coerce.date().transform((date) => {
        dayjs.extend(localizedFormat)

        return dayjs(date)
    }),
    user_type: z.string(),
    user_uuid: z.string().uuid(),
    uuid: z.string().uuid(),
})

export const notificationSettingsSchema = z.array(notificationSettingSchema)

export const paginatedNotificationSettingsSchema = z.object({
    data: notificationSettingsSchema,
    links: paginationLinksSchema,
    meta: paginationMetaSchema,
})

export type NotificationSetting = z.infer<typeof notificationSettingSchema>
export type NotificationSettings = z.infer<typeof notificationSettingsSchema>
